const els = {
    $tabbed: () => $('[data-tabbed]'),
    $toggle: ($tabbed) => $tabbed.find('[data-toggle]'),
    $indicator: ($tabbed) => $tabbed.find('[data-indicator]'),
    $options: ($tabbed) => $tabbed.find('[data-option]'),
    $option: ($tabbed, option) => (
        els.$options($tabbed).filter(`[data-option="${option}"]`)
    ),
    $tabs: () => $('[data-tab]'),
    $tab: ($tabs, tab) => $tabs.filter(`[data-tab="${tab}"]`),
};

export default els;

